export default __webpack_public_path__ + "static/media/search-no-results.7b2a432d.png";